export default "__VITE_ASSET__BV7mLLfv__"